import React, {Component} from 'react';
import * as nodemailer from "nodemailer";

class GoogleMail extends Component {

    constructor(props, context) {
        super(props, context);

    }


    render() {
        return (

            <div className="template-component-contact-form">

                <form>


                    <div className="template-layout-50x50 template-clear-fix">


                        <div className="template-layout-column-left">


                            <div className="template-form-line template-state-block">
                                <label htmlFor="contact-form-name">Your Name *</label>
                                <input type="text" name="contact-form-name" id="contact-form-name"/>
                            </div>


                            <div className="template-form-line template-state-block">
                                <label htmlFor="contact-form-email">Your E-mail *</label>
                                <input type="text" name="contact-form-email" id="contact-form-email"/>
                            </div>


                            <div className="template-form-line template-state-block">
                                <label htmlFor="contact-form-subject">Subject</label>
                                <input type="text" name="contact-form-subject" id="contact-form-subject"/>
                            </div>

                        </div>


                        <div className="template-layout-column-right">
                            <div className="template-form-line template-state-block">
                                <label htmlFor="contact-form-message">Message *</label>
                                <textarea rows="1" cols="1" name="contact-form-message"
                                          id="contact-form-message"></textarea>
                            </div>
                        </div>

                    </div>

                    <div className="template-form-line template-form-line-submit template-align-center">

                        <div className="template-state-block">


                            <input className="template-component-button template-component-button-style-1"
                                   value="Send message" name="contact-form-submit" onClick={()=>this.mail()}
                                   id="contact-form-submit"/>

                        </div>

                    </div>

                </form>

            </div>
        );
    }
}

export default GoogleMail;
